import {Component, OnInit, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {NavParams} from '@ionic/angular';
import {ApiResponseService} from 'src/app/services/api-response.service';
import {GlobalService} from 'src/app/services/global.service';

export type MfaMethodType = 'phoneNumber' | 'email';

@Component({
    selector: 'app-mfa-enable-modal',
    templateUrl: './mfa-enable.modal.html',
})
export class MfaEnableModal implements OnInit {
    length = 4;
    disablePhoneSubmit = true;
    disableEmailSubmit = true;
    otp;
    mfaType: MfaMethodType | 'both' | null = null;
    /** When set, skip type selection and show only OTP step for this method */
    preselectedType: MfaMethodType | null = null;
    /** When adding another method, only show types not in this list (e.g. ['phoneNumber'] to show only Email) */
    enabledMethods: MfaMethodType[] = [];
    @ViewChild('stepper')
    stepper: MatStepper;
    constructor(
        private apiResponseService: ApiResponseService,
        public global: GlobalService,
        private navParams: NavParams
    ) {
        this.preselectedType = this.navParams.get('preselectedType') || null;
        this.enabledMethods = this.navParams.get('enabledMethods') || [];
    }
    ngOnInit(): void {
        if (this.preselectedType) {
            this.mfaType = this.preselectedType;
            this.onMfaTypeChange(this.preselectedType);
        }
    }
    get showTypeSelection(): boolean {
        return !this.preselectedType;
    }
    get isPhoneEnabled(): boolean {
        return this.enabledMethods.includes('phoneNumber');
    }
    get isEmailEnabled(): boolean {
        return this.enabledMethods.includes('email');
    }
    onMfaTypeChange(event) {
        if (event === 'phoneNumber') {
            this.initiatePhoneNumberMFA();
        } else if (event === 'email') {
            this.initiateEmailMFA();
        } else if (event === 'both') {
            this.initiatePhoneNumberMFA();
            this.initiateEmailMFA();
        }
    }
    onOtpChange(event) {
        const otp = event.target.value;
        this.otp = otp;

        // Check if the OTP is of the correct length and numeric
        if (otp.length === this.length && /^\d+$/.test(otp)) {
            this.disableEmailSubmit = false;
        } else {
            this.disableEmailSubmit = true;
        }
    }
    onPhoneOtpChange(event) {
        const otp = event.target.value;
        this.otp = otp;

        // Check if the OTP is of the correct length and numeric
        if (otp.length === this.length && /^\d+$/.test(otp)) {
            this.disablePhoneSubmit = false;
        } else {
            this.disablePhoneSubmit = true;
        }
    }
    initiatePhoneNumberMFA() {
        this.apiResponseService.initiatePhoneNumberMFA().subscribe(
            (response) => {
                // Handle success response if needed
            },
            (error) => {
                this.global.closeModal();
                this.global.basicAlert('Invalid Phone number', 'The Phone number in your profile appears to be invalid. Please update it to continue.');
            }
        );
    }
    initiateEmailMFA() {
        this.apiResponseService.initiateEmailMFA().subscribe(
            (response) => {
                // Handle success response if needed
            },
            (error) => {
                this.global.closeModal();
                this.global.basicAlert('Invalid Email Address', 'The email address in your profile appears to be invalid. Please update it to continue.');
            }
        );
    }
    verifyPhoneNumberApi() {
        this.apiResponseService.verifyPhoneNumberMfaCode(this.otp, this.global.isMobileApplication).subscribe((response) => {
            if (response.message === 'verification_success') {
                this.global.basicAlert('Success', 'Verification successful');
                if (this.mfaType === 'phoneNumber') {
                    this.global.closeModal({verified: true, type: 'phoneNumber'});
                } else if (this.mfaType === 'both') {
                    this.otp = null;
                    this.stepper.next();
                }
            }
        });
    }
    verifyEmailApi() {
        this.apiResponseService.verifyEmailMfaCode(this.otp, this.global.isMobileApplication).subscribe((response) => {
            if (response.message === 'verification_successful') {
                this.global.basicAlert('Success', 'Verification successful');
                if (this.mfaType === 'email') {
                    this.global.closeModal({verified: true, type: 'email'});
                } else if (this.mfaType === 'both') {
                    this.global.closeModal({verified: true, type: 'both'});
                }
            }
        });
    }
}
